import { CanActivateFn, Router } from '@angular/router';
import { CompanyService } from '../company/company.service';
import {
  ELandingType,
  ILandingOrganizationInactive,
  LandingOrganizationInactiveService,
} from '../../layout/landing-layout/landing-organization-inactive/landing-organization-inactive.service';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { LoggingService } from '../utils/logging.service';

export const businessInactiveGuard: CanActivateFn = () => {
  const router = inject(Router);
  const companyService = inject(CompanyService);
  const landingOrganizationInactiveService = inject(LandingOrganizationInactiveService);
  const loggingService = inject(LoggingService);

  // Check if bizId exists before making the API call
  const bizId = companyService.getBizState();
  if (!bizId) {
    loggingService.log('businessInactiveGuard: bizId is null or undefined, allowing navigation');
    return of(true); // Allow navigation if bizId is not set
  }

  loggingService.log('businessInactiveGuard: bizId :: =>', bizId);

  return companyService.getBusinessDetail().pipe(
    map((res: any) => {
      const isActive = res?.isActive ?? true; // Default to true if undefined
      loggingService.log('||| isActive :: =>', isActive);
      if (!isActive) {
        const landingData: ILandingOrganizationInactive = {
          type: ELandingType.BUSINESS,
          title: 'organization_inactive.business.header',
          subTitle: 'organization_inactive.business.sub_header1',
          image: '',
        };
        landingOrganizationInactiveService.setLandingOrganizationInactive(landingData);
        router.navigateByUrl('/organization-inactive');
        return false;
      }
      return true;
    }),
    catchError((error: any) => {
      loggingService.log('Error fetching business details:', error);
      return of(false);
    })
  );
};
